import React from 'react';
import { COMPANIES } from '../../../../../utils/constants/api';
import { CompanyFromApi } from '../../../../../shared/Company/data/CompanyFromApi';
import ConfirmDeleteModal from '../../../Layer/Modal/ConfirmDeleteModal';
import {ValidationError} from "../../../../../shared/Common/Error/ValidationError";

type DeleteCompany = {
    opened: boolean,
    onOk: () => void,
    onClose: () => any,
    company: CompanyFromApi
};

function DeleteCompany(props: DeleteCompany) {
    function deleteCompany(): void {
        fetch(COMPANIES + '/' + props.company.id, {
            method: 'DELETE',
        })
            .then(response => {
                if (response.ok) {
                    props.onOk();
                } else {
                    response.json().then((jsonData: any) => {
                        if (jsonData.error) {
                            alert(jsonData.error);
                        } else if (Array.isArray(jsonData) && jsonData.length > 0) {
                            const errors: ValidationError[] = jsonData;
                            validate(errors);
                        }
                    });
                }
            });
    }

    return (
        <ConfirmDeleteModal
            opened={ props.opened }
            modalTitle='Delete Company'
            cancelText='Cancel'
            deleteText={'<span>&laquo;' + props.company.name + '&raquo;</span>'}
            okText='Delete'
            onCancel={ props.onClose }
            onOk={ deleteCompany }
        />
    )
}

function validate(errors: ValidationError[]): void {
    errors.forEach((error: ValidationError) => {
        if (error.property === 'company') {
            alert(error.message);
        }
    });
}
export default DeleteCompany;